module.exports = __webpack_public_path__ + "img/bauteilverdrehung.e1f89b83.jpg";